import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import PageLoader from 'shared/components/PageLoader';
import { useCourierAuth } from 'features/courier-auth/context/CourierAuthContext';

const CourierProtectedRoute: React.FC = () => {
  const { courier, loading } = useCourierAuth();
  if (loading) return <PageLoader />;
  if (!courier) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export default CourierProtectedRoute;
